import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import useActionsFilteredAlertsMessages from '@/components/AlertsMessages/composables/useActionsFilteredAlertsMessages'
import ServerPaginationComponent from '@/components/Pagination/ServerPaginationComponent.vue'
import { onMounted, ref } from 'vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import { AlertMessageOrderEnum, AlertMessageOrderTypeEnum, ListStatus } from '@/store/modules/alertsMessages/alertsMessagesTypes'
import LexonSelectComponent from '@/components/forms/fields/LexonSelect/LexonSelectComponent.vue'
import AlertsMessagesListComponent from './AlertsMessagesListComponent.vue'
import { getObjectByKeyAndValue } from '@/helpers/object'

// COMPOSABLE

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsMessagesComponent',
  setup(__props) {

const { filteredList, status, loadFilteredList, setFilter, selectedOrderType } = useActionsFilteredAlertsMessages()

// TRANSLATIONS
const { t } = useI18n()

const texts = {
  alerts: t('navigation.alerts_menu.alerts'),
  loadError: t('components.alerts_messages.load_error'),
  viewMoreAlerts: t('navigation.alerts_menu.more_alerts'),
  link: t('navigation.alerts_menu.no_data.link'),
  noData: t('navigation.alerts_menu.no_data.text'),
  expirationOrder: t('components.alerts_messages.expiration_order'),
  chronologicalOrder: t('components.alerts_messages.chronological_order'),
  changeVisibilityError: t('components.alerts_messages.change_visibility_error'),
  next: t('navigation.alerts_menu.next'),
  last: t('navigation.alerts_menu.last')
}

// DATA
const noDataIcon = Icons.ARCHIVE_EMPTY
const errorIcon = Icons.CLOSE_ROUND
const alertConfigPanelURL = `/panel-configuracion/alertas`
const path = 'navigation.alerts_menu.no_data.link_text'
const orderTypeItems = [
  { value: AlertMessageOrderTypeEnum.ASC, text: texts.next },
  { value: AlertMessageOrderTypeEnum.DESC, text: texts.last }
]
const numPage = ref<number>(1)
const showListSpinner = ref<boolean>(false)
const selectedOrderItem = ref<any>(getObjectByKeyAndValue(orderTypeItems, 'value', selectedOrderType.value))

// METHODS
async function onPageChanged(direction: number) {
  showListSpinner.value = true
  if (direction === 1) {
    numPage.value += 1
  } else {
    numPage.value -= 1
  }
  await setFilter({ page: numPage.value })
  await init()
  showListSpinner.value = false
}

async function onOrderChange(orderType: AlertMessageOrderTypeEnum) {
  showListSpinner.value = true
  await setFilter({ order: AlertMessageOrderEnum.EXPIR, orderType })
  await init()
  showListSpinner.value = false
}

async function init() {
  await loadFilteredList()
}

// HOOKS
onMounted(async () => {
  await init()
})

return { __sfc: true,filteredList, status, loadFilteredList, setFilter, selectedOrderType, t, texts, noDataIcon, errorIcon, alertConfigPanelURL, path, orderTypeItems, numPage, showListSpinner, selectedOrderItem, onPageChanged, onOrderChange, init, ServerPaginationComponent, SpinnerLayerComponent, ListStatus, LexonSelectComponent, AlertsMessagesListComponent }
}

})